import { BACKEND_URI } from "../entries";
import { secureAPICall } from "../utils/sessionUtils";


export const requestNotifications = async ({ nFirst = 30, unread_only, verbose = false }) => {
    const formData = new FormData();
    formData.append("n_first", nFirst)
    formData.append("unread_only", unread_only)
    return secureAPICall({endpoint: BACKEND_URI+"/api/notification/get-notifications", body: formData, verbose: verbose})
}